import GetQueryParam from '../util/get-query-param';

class MovieController {
    constructor() {
        let tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        let firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        this.player = null;
        this.playerbottom = null;
        window.onYouTubeIframeAPIReady = () => {
            this.playerbottom = new YT.Player('js-popup__moviebottom', {});
        };
        this.setPopupMovieBottom();

        let q = new GetQueryParam();
        // console.log(q.movie);
        if (q.movie) {
            let margin = $('#js-global-header').height();
            
            setTimeout(()=>{
                $(`#js-movie-${q.movie}`).trigger('click');
                $('html, body').stop().animate({
                    scrollTop: $(`#js-movie-${q.movie}`).offset().top - margin
                },500);
            }, 2500);
        }
    }

    setPopupMovieBottom() {

        
        let $link = $('.movie-content__item a');
        let $pop = $('.style-detail__moviebottom-popup');
        let _this = this;
        $link.each(function(){
            let $this = $(this);
            $this.on('click', function (e) {
                e.preventDefault();
                $pop.toggleClass('is-open');
                _this.playerbottom.loadVideoById({videoId: $this.data('yid')});
                setTimeout(()=>{
                    _this.playerbottom.playVideo();
                }, 1600);
            });
        });
       
        $pop.on('click', function (e) {
            e.preventDefault();
            // console.log(e.currentTarget);
            if ($(e.target).hasClass('is-open')) {
                $pop.removeClass('is-open');
                setTimeout(()=>{
                    _this.playerbottom.pauseVideo();
                }, 500);
               
                // console.log(_this.playerbottom.pauseVideo());
            }
        });

        $('.common-popup__close').on('click', function (e) {
            e.preventDefault();
            $pop.removeClass('is-open');
            _this.playerbottom.pauseVideo();
            $bg.play();
        });
    }
}

export default MovieController;
